export const en = {
    nav: {
      about: 'About',
      tours: 'Travel',
      realEstate: 'Real Estate',
      news: 'News',
      insights: 'Investment Insights',
      contact: 'Contact',
      tourDropdown: {
        dayTours: 'Istanbul Day Tours',
        shoreExcursions: 'Istanbul Shore Excursions',
        foodTour: 'Istanbul Food Tour',
        reConsulting: 'Real Estate Consulting Tour (Free)',
        layoverTour: 'Istanbul Layover Tour',
        medicalTourism: 'Medical Tourism'
      },
      realEstateDropdown: {
        besiktas: 'Beşiktaş',
        florya: 'Bakırköy',
        kanalIstanbul: 'Kanal Istanbul',
        skyland: 'Major Skyscraper',
        merkezefendi: 'Zeytinburnu',
        tualComfort: 'Kanal Istanbul 2nd',
        referansBeylikduzu: 'European Side Prime Residences'
      }
    },
    hero: {
      title: 'Your Gateway to Istanbul',
      subtitle: 'Investment & Tourism Excellence',
      motto: '"We are your trusted partner in Turkey"',
      exploreTours: 'Explore Tours',
      viewProperties: 'View Properties'
    },
    about: {
      title: 'About Viaturkey',
      intro: 'Viaturkey is a full service, successful Istanbul based Company focusing on Tourism, Consulting & Real Estate Advisory Services in & outside of Istanbul and rest of Turkey.',
      tourism: 'Tourism Services',
      tourismDesc: 'Comprehensive Istanbul & Turkey tourism experiences tailored to your needs.',
      realEstate: 'Real Estate Consultancy',
      realEstateDesc: 'Expert guidance in Turkish real estate investment opportunities.',
      realEstateExtra: 'Real estate property management services can also be provided by request and with POA.',
      residence: 'Residence Permit',
      residenceDesc: 'Professional assistance with Turkish residence permit applications.',
      citizenship: 'Turkish Citizenship',
      citizenshipDesc: 'Complete support for Turkish citizenship acquisition process.',
      establishBusiness: 'Establishing Business',
      establishBusinessDesc: 'Expert assistance in setting up and registering your business in Turkey.',
      workPermit: 'Obtaining Work Permit',
      workPermitDesc: 'Comprehensive guidance on work permit applications for foreign nationals in Turkey.',
      founderGreeting: 'Hello, this is the co-founder of Viaturkey Investments & Tourism Co. My name is Akin Guzel. I am a serial entrepreneur in Tourism Operations & Real Estate Advisory and furthermore a Trusted Local Business Partner based in Istanbul, Turkey. With our team of experts with boots on the ground, we look forward to speaking with you regarding your plans in Turkey.',
      founderName: 'Akin Guzel',
      founderTitle: 'Co-Founder, Viaturkey Investments & Tourism Co.'
    },
    interestField: {
      title: 'Your Interested Field About Turkey',
      travel: 'Travel Viaturkey',
      travelDesc: 'Explore Istanbul with private tours & expert local guides',
      invest: 'Invest Viaturkey',
      investDesc: 'Luxury real estate & investment opportunities in Istanbul',
      news: 'News Viaturkey',
      newsDesc: 'Latest lifestyle & business news from Turkey',
      insights: 'Invest Insights Viaturkey',
      insightsDesc: 'Istanbul mega projects, market data & tourism figures for investors',
    },
    tours: {
      title: 'Tourism Services',
      subtitle: 'Explore Istanbul and Turkey with expert local guides',
      whyBookTitle: 'Why Book With Us?',
      bestPrice: 'Best Price Guarantee – Book Direct & Save',
      bestPriceDesc: 'By reaching out to us directly through our website or email, you bypass third-party platforms like TripAdvisor / Viator / Get Your Guide that charge up to 25% in commissions. We prefer to pass those savings on to you in the form of a direct-booking discount.',
      tailorMade: 'Tailor-Made Itineraries',
      tailorMadeDesc: 'Your journey shouldn\'t be one-size-fits-all. Whether you have a specific historical site in mind or a hidden gem you\'ve been dreaming of, we specialize in customizing every detail to fit your personal interests.',
      expertGuides: 'Expert Local Guides',
      expertGuidesDesc: 'Our most popular guides are often in high demand and their schedules fill up quickly. Booking in advance ensures you secure your preferred date and time with a top-tier professional.',
      transparency: 'Total Transparency',
      transparencyDesc: 'No hidden fees or surprises. We provide clear details on your itinerary, duration, and exactly what is included. You\'ll always know the terms and cancellation policy before you finalize your adventure.',
      duration: 'Duration',
      highlights: 'Highlights',
      included: 'Included',
      excluded: 'Excluded',
      contactPrice: 'Contact for best price',
      inquireNow: 'Inquire Now',
      alsoAvailable: 'Also Available',
      flexibleToursIntro: 'Christian Heritage Tours, Archaeology Tours, and Shopping Tours can also be done with a flexible itinerary at your own pace in accordance with your plan.',
      flexibleToursContact: 'Please contact for details',
      christianHeritage: 'Christian Heritage Tours',
      archaeologyTours: 'Archaeology Tours',
      shoppingTours: 'Shopping Tours',
      pricingBanner: 'Private Cultural Guidance - Tour Management starting from $160 per group min 2 to 8 people.',
      pricingSolo: 'Please kindly request for quote on Solo travellers or FIT / Incentive Groups.',
      priceFrom200: 'Starting from $200 USD',
      priceFrom150: 'Starting from $150 USD per person',
      priceFrom175: 'Starting from $175 per Group',
      priceFrom160: 'Starting from $160 per Group',
      priceFrom185: 'Starting from $185 per Group',
      contactWhatsApp: 'Contact via WhatsApp',
      commissionWarning: {
        title: 'Important Notice',
        message: 'Please bear in mind that, these 3 websites are taking 25% commission per person from the tour service in which you are admittedly paying money for 3rd party that are not involved in any of the real operations & expertise & efforts at all!',
        directMessage: 'By booking directly with us, your money goes straight to the actual service provider — no middleman, no hidden fees.'
      },
      businessDining: {
        tip: 'Tips For Business Oriented Travellers In Istanbul',
        title: 'Top Dining Places In Istanbul For Business Meetings',
        specialty: 'Specialty',
        steakhouseTitle: 'The Steakhouse & Kebab Icons',
        seafoodTitle: 'Bosphorus & Waterfront Seafood',
        italianTitle: 'Sophisticated World & Italian Cuisine',
        fineDiningTitle: 'View-Focused Fine Dining'
      },
      videoSection: {
        title: 'Explore Istanbul With Us',
        desc: 'Join our guided tour through Istanbul\'s most iconic landmarks — the magnificent Blue Mosque and the historic Hagia Sophia. Experience the rich history, stunning architecture, and cultural heritage that makes Istanbul one of the world\'s most captivating cities.'
      },
      realEstateConsulting: {
        title: 'Real Estate Consulting Service',
        vanInfo: 'Private van with chauffeur can be arranged at its cost.',
        consultingInfo: 'Min 3-5 hours of free Real Estate consulting / advisory is to be provided.',
        description: 'This service can be provided to guests (special request) who wants to have the most detailed idea about Real Estate / Investment market in Istanbul.',
        ctaText: 'Schedule a 15 Minute Call to talk about your Investment Plans in Turkey'
      },
      includedItems: [
        'Private Personalized Tour Guide',
        'Fast Track Entrance To All Museums (except Hagia Sophia)',
        'Scholar-knowledge Guide',
        '5-8 hours of Tour duration',
        'Pick up from hotel with/without Air conditioned Van'
      ],
      excludedItems: [
        'Guide tips / gratuity',
        'Entrance fee to all Museums',
        'Lunch',
        'All kinds of expenditures at the duration of the tour'
      ],
      tourDetails: {
        '1': {
          name: 'Daily Old City Istanbul Tour',
          description: 'Explore the historic heart of Istanbul with visits to iconic landmarks. Minimum of 5-8 hours duration with your expert local guide telling you all history with anecdotes, traditions, and real life stories.',
          duration: 'Minimum of 5-8 hours',
          highlights: ['Hagia Sophia', 'Blue Mosque', 'Topkapi Palace', 'Grand Bazaar', 'Hippodrome'],
          whatsappMsg: 'Hi, I am interested in the Daily Old City Istanbul Tour. Could you please provide more details?',
          details: '**Tour Pricing Information:**\nThe main price given will be for a walking tour of the museums with an expert professional guide. If you require a special car or air-conditioned van, additional price will be added.\n\n**Possible Sites to Visit:**\n• Hagia Sophia Museum (25 EUR/person) - 6th century Christian cathedral turned into mosque in 15th century by Ottomans, currently used as half museum and half mosque\n• Sultanahmet (Blue Mosque) - FREE - 17th century beautifully decorated Ottoman Classique era Mosque with biggest ceramic collection in Istanbul\n• Hippodrome - FREE - Open air place called Horse square during Ottoman period, including the oldest standing columns in Istanbul\n• Underground Basilica Cistern (45 USD/person) - Used as water tank during Roman period, built in 6th century Justinian Era, now a museum\n• Topkapi Palace Museum (63 USD/person) - House of Sultans from 15th century until early 19th century, now used as museum\n• Grand Bazaar - FREE - More than 3000 merchants including carpet shops, jewelry merchants, spice shops, and many more!\n\n**Alternative Options:**\n• Spice Bazaar - FREE - Dating back from 17th century with 90+ active merchants\n• Bosphorus Cruise - 300 Turkish Liras per person for 1.5 hours'
        },
        '2': {
          name: 'Shore Excursions - Old City Istanbul Tour',
          description: 'Perfect for cruise passengers! Comprehensive tour of Istanbul\'s Old City with convenient port pickup and drop-off. Minimum of 5-8 hours duration with your expert local guide.',
          duration: 'Minimum of 5-8 hours',
          highlights: ['Port Pickup', 'Old City Highlights', 'Return to Port'],
          whatsappMsg: 'Hi, I am interested in the Shore Excursions Tour. Could you please provide more details?',
          details: '**Tour Pricing Information:**\nThe main price given will be for a walking tour of the museums with an expert professional guide. If you require a special car or air-conditioned van, additional price will be added.\n\n**Possible Sites to Visit:**\n• Hagia Sophia Museum (25 EUR/person) - 6th century Christian cathedral turned into mosque in 15th century by Ottomans, currently used as half museum and half mosque\n• Sultanahmet (Blue Mosque) - FREE - 17th century beautifully decorated Ottoman Classique era Mosque with biggest ceramic collection in Istanbul\n• Hippodrome - FREE - Open air place called Horse square during Ottoman period, including the oldest standing columns in Istanbul\n• Underground Basilica Cistern (45 USD/person) - Used as water tank during Roman period, built in 6th century Justinian Era, now a museum\n• Topkapi Palace Museum (63 USD/person) - House of Sultans from 15th century until early 19th century, now used as museum\n• Grand Bazaar - FREE - More than 3000 merchants including carpet shops, jewelry merchants, spice shops, and many more!\n\n**Alternative Options:**\n• Spice Bazaar - FREE - Dating back from 17th century with 90+ active merchants\n• Bosphorus Cruise - 300 Turkish Liras per person for 1.5 hours'
        },
        '3': {
          name: 'Layover Tours from Istanbul / Sabiha Gökçen Airports',
          description: 'Make the most of your layover! Customized tours from both Istanbul Airport and Sabiha Gökçen Airport.',
          duration: '4-8 hours (flexible)',
          highlights: ['Airport Pickup & Drop-off', 'Flexible Itinerary', 'Major Attractions', 'Shopping Time'],
          whatsappMsg: 'Hi, I am interested in the Istanbul Layover Tour. Here are my flight details:\nArrival Flight No: \nDeparture Flight No: \nLayover Duration: \nTime Available for Touring: Approx. ___ hours\nNumber of People: ',
          details: 'Please kindly inform us on the details of your flight to Istanbul and other related details:\n\nArrival & Flight Details:\n• Arrival Flight No: ............\n• Departure Flight No: ............\n• Layover Duration: ............\n• Time Available for Touring: Approx. ......... Number of Hours\n\nTour Option: Full-Day Layover Tour (Private)\nA comfortable and relaxed introduction to Istanbul with a local guide, ideal for first-time visitors.\n\nSuggested Itinerary:\n• Pickup from the airport after passport control\n• Transfer to Sultanahmet (Old City)\n• Visit of Blue Mosque, Hagia Sophia & Hippodrome Square\n• Stop at Arasta Bazaar or Spice Market\n• Ferry ride across the Bosphorus to the Asian side (optional and time-dependent)\n• Turkish dinner (self-paid) or local street food sampling\n• Transfer back to the Airport'
        },
        '4': {
          name: 'Istanbul Food Tour - Taste of 2 Continents',
          description: 'Culinary journey through Istanbul\'s European and Asian sides. Experience authentic Turkish cuisine and local flavors.',
          duration: '5-6 hours',
          highlights: ['Traditional Turkish Breakfast', 'Street Food', 'Local Markets', 'Bosphorus Crossing', 'Sweet Treats'],
          whatsappMsg: 'Hi, I am interested in the Istanbul Food Tour. Could you please provide more details?',
          details: 'At least 5-8 stops including:\n• Traditional Turkish breakfast\n• 3 side dishes minimum\n• 1 main dish\n• Special local desserts\n\nYour guide, as a local foodie, will describe interesting stories and anecdotes while providing an extensive presentation of Turkish cuisine.\n\nPlease contact for price quote per person.'
        },
        '5': {
          name: 'Airport Transfers from Istanbul / Sabiha Gökçen Airports',
          description: 'Comfortable and reliable airport transfer services. Private vehicles with professional drivers.',
          duration: 'As needed',
          highlights: ['Door-to-door Service', 'Professional Drivers', 'Modern Vehicles', '24/7 Available', 'Flight Tracking'],
          whatsappMsg: 'Hi, I am interested in Airport Transfer services. Could you please provide a quote?',
          includedItems: [
            'Meet & Greet at Airport',
            'Door-to-Door Service',
            'Professional Drivers',
            'Modern - Airconditioned Vehicles - Soft Drinks On Vehicle',
            '24/7 Available',
            'Flight Tracking'
          ],
          excludedItems: [
            'Pricing starting from 1-4 passengers',
            'Pricing for 5-10 passengers',
            'Pricing for 11 and above',
            'Please contact us for a quote'
          ]
        }
      }
    },
    realEstate: {
      title: 'Investment Opportunities',
      titleHighlight1: 'Investment',
      titleHighlight2: 'Opportunities',
      downloadBrochure: 'Download Brochure',
      requestInfo: 'Request Information',
      discoveryCall: 'Book a 15-minute discovery call to discuss your investment goals in Istanbul & Turkiye.',
      moreProjects: 'More projects coming soon...',
      officialResources: 'Official Investment Resources',
      acquiringPropertyTitle: 'Acquiring Property & Citizenship in Turkiye',
      acquiringPropertyDesc: 'Official guide on procedures, documents, and guidelines for foreign nationals acquiring property and citizenship.',
      citizenshipGuideTitle: 'Guide to Foreign Citizens\' Acquisition of Turkish Citizenship',
      citizenshipGuideDesc: 'Comprehensive official PDF guide from the Presidency of the Republic of Turkiye Investment Office.',
      residencePermitTitle: 'Obtaining a Residence Permit',
      residencePermitDesc: 'Procedures and required documents for foreign nationals to obtain residence permits in Turkiye.',
      establishBusinessTitle: 'Establishing a Business',
      establishBusinessDesc: 'Information about starting and registering a company in Turkiye, including types and establishment process.',
      workPermitTitle: 'Obtaining a Work Permit',
      workPermitDesc: 'Guidelines for foreign nationals on obtaining work permits to work legally in Turkiye.',
      developer: 'Developer',
      status: 'Status',
      apartmentTypes: 'Apartment Types',
      keyFeatures: 'Key Features',
      projectDetails: {
        'besiktas-luxury': {
          name: 'Luxury Residential Project in Beşiktaş',
          location: 'Şişli - Mecidiyeköy, Istanbul',
          description: 'A luxury residential project combining Istanbul\'s historical texture and modern living, offering an exclusive lifestyle with Bosphorus view. Developed by Premium Developer.',
          highlights: [
            '175 apartments across 6 floors',
            'Bosphorus, landscape, and city views',
            'Indoor swimming pool, gym, spa',
            '24/7 security, indoor parking',
            'Walking distance to metro and ferry',
            'Turkish Citizenship eligible',
            'Residence Permit eligible'
          ]
        },
        'nivak-florya': {
          name: 'Ultra Luxury Living Residences In the Heart Of District of Bakırköy',
          location: 'Bakırköy, Istanbul',
          description: 'A lifestyle at the level you truly deserve. A private and boutique community with nature-inspired architecture, man-made lake, and unique green landscapes. Features fully European-sourced materials and natural wood and stone throughout all residences.',
          highlights: [
            'Only 96 exclusive units',
            'Ceiling height over 3.20 meters',
            'Steps away from coastline and seaside park',
            'Adjacent to Atatürk Park',
            'Indoor swimming pool, Turkish bath, sauna',
            'Fitness center and Pilates studio',
            'Football and basketball courts',
            'Turkish Citizenship eligible',
            'Ready for delivery - June 2025'
          ]
        },
        'tual-golyaka-kanal': {
          name: 'Kanal Istanbul Residences Project',
          location: 'Istanbul European Side',
          description: 'A low-density residential project combining modern urban living with nature-focused design. Located near the Kanal Istanbul corridor, offering strong future value potential. Government-backed developer with 70% green areas.',
          highlights: [
            '26,000 sqm land area - 70% green spaces',
            'Horizontal low-rise architecture',
            'Close to Küçükçekmece Lake',
            'Easy access to TEM Highway',
            'Outdoor swimming pool and fitness center',
            'Walking and jogging paths',
            'Private gardens and large terraces',
            '24/7 security with controlled entrance',
            'Turkish Citizenship eligible',
            'Near Channel Istanbul corridor'
          ]
        },
        'alya-merkezefendi': {
          name: 'Very Central New Project Near Fatih District',
          location: 'Zeytinburnu, Istanbul',
          description: 'A modern residential complex in the heart of Zeytinburnu offering comfortable urban living with excellent transportation connections. Features 467 apartments across 6 floors with rich social amenities.',
          highlights: [
            '467 apartments and 15 commercial units',
            '17,928 sqm land area, 80,124 sqm construction area',
            'Indoor swimming pool, fitness gym',
            'Basketball and football courts',
            'Turkish bath, sauna, steam room',
            'Children\'s playgrounds and walking paths',
            '24/7 security, indoor parking',
            '650m to Cevizlibağ Metrobus (walking distance)',
            'Turkish Citizenship eligible',
            'Residence Permit eligible'
          ]
        },
        'skyland-prime': {
          name: 'Şişli Major Prime Skyscraper Residence',
          location: 'Şişli - Maslak, Istanbul',
          description: 'The tallest building complex in Turkey, located between Levent and Maslak. Designed by architect Peter Vaughan of Broadway Malyan, blending high technology with innovative architecture.',
          highlights: [
            'Tallest building complex in Turkey - 1,450 units',
            '46,000 sqm construction area',
            'Central location between Levent and Maslak',
            'VIP entrance lobby and smart home system',
            'Indoor & outdoor swimming pools',
            'Shopping mall, food court, gym',
            'Turkish bath, sauna, pilates room',
            '24/7 security, shuttle service, parking',
            'Private entrance from TEM Highway',
            'Forest & city views - Immediate delivery',
            'Turkish Citizenship eligible'
          ]
        }
      }
    },
    investmentInsights: {
      title: 'Investment Insights: Istanbul Mega Projects & Market Outlook',
      marketNews: 'Market & Tourism News',
    },
    news: {
      title: 'Lifestyle & Business News In Turkey',
      tourismRevenue: {
        title: 'Turkiye Tops 2025 Tourism Revenue Target, Foreign Arrivals Hit Record',
        desc: '$65.2 billion in tourism revenue with 64 million tourists in 2025 — both all-time records.'
      },
      realEstateMarket: {
        title: 'Turkiye Real Estate Market — A European Powerhouse',
        desc: 'Turkiye is one of the most promising real estate markets in Europe. Strategically situated at the crossroads of Europe, the Middle East, and Central Asia, home to 85 million people. FDI inflows increased to USD 11.3 billion, while real estate FDI was USD 2.8 billion, 25% of total FDI in 2024.',
        cta: 'For more information click here'
      },
      tourismRecord: {
        title: 'Turkiye Posts Record High Tourism Revenue Despite Geopolitical Challenges',
        desc: '64M tourists and $65.2B revenue in 2025 — Turkiye becomes the 4th most visited country in the world.'
      }
    },
    kanalIstanbul: {
      sectionTitle: 'Kanal Istanbul Project',
      projectPurpose: 'Kanal Istanbul - Project Purpose',
      projectPurposeDesc: 'Learn about the purpose and vision behind the Kanal Istanbul mega-project, an alternative waterway to the Bosphorus.',
      videos: 'Kanal Istanbul - Videos & Documentaries',
      videosDesc: 'Watch official videos and documentaries about the Kanal Istanbul project developments.',
      arabicVideoTitle: 'Kanal Istanbul - Arabic Documentary',
      arabicVideoDesc: 'Watch the Kanal Istanbul project documentary in Arabic.'
    },
    tersaneIstanbul: {
      sectionTitle: 'Tersane Istanbul',
      description: 'Tersane Istanbul is an impressive urban transformation project that converts Turkey\'s largest industrial heritage site into a modern waterfront district and a world-class destination. Rising on the historic Tersane-i Amire site on the northern shore of the Golden Horn, the project brings new life to the historic coastline with five-star hotels, shops, social spaces, museums, culture and performance centers, residences, marinas, and a nearly two-kilometer-long waterfront promenade along the Golden Horn.',
      ourStory: 'Aliée Istanbul - Our Story',
      ourStoryDesc: 'Discover the journey from historic Ottoman shipyard to a refined world-class destination on the Golden Horn.',
      thingsToDo: 'Aliée Istanbul - Things to Do',
      thingsToDoDesc: 'Explore luxury experiences — Bosphorus sailing, art studios, Sunday brunch, biohacking, and the art of Ebru.'
    },
    goturkiyeBlog: {
      intro: 'Everything about Turkey..',
      readMore: 'Read Article',
      blogTitles: [
        'Digital Nomad Visa - Turkey 2026',
        '10 Ways To Say Hello & Goodbye',
        '10 Best Souvenirs to Buy from Istanbul',
        '10 Iconic Street Foods in Turkiye',
        '10 Most Popular Spices in Turkish Cuisine',
        '10 Things to Do in Istanbul',
        '10 Turkish Desserts You Need to Try',
        '10 Turkish Souvenirs from Local Crafts Shops',
        '16 Foods You Have to Try in Turkiye',
        "13 Things You'll Only Understand If You've Been to Turkiye"
      ]
    },
    digitalNomad: {
      cta: 'For the most reliable and up-to-date information, please visit the link'
    },
    tags: {
      title: 'Our Tags'
    },
    newsletter: {
      title: 'Newsletter',
      description: 'Stay updated with the latest news, tours, and investment opportunities in Turkey.',
      emailPlaceholder: 'Your email address',
      signUp: 'SIGN UP',
      subscribing: 'Subscribing...',
      success: 'Successfully subscribed to newsletter!',
      invalidEmail: 'Please enter a valid email address.',
      error: 'Error subscribing. Please try again.'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'What is the best private tour company in Istanbul?',
      a1: 'Viaturkey Investments & Tourism is a top-rated private tour company in Istanbul offering personalized guided tours in English, Russian, Arabic, and Turkish. We provide Old City tours, Bosphorus cruises, food tours, shore excursions, and airport layover tours with expert local guides. Book directly with no middleman fees.',
      q2: 'How can I get Turkish citizenship by investment?',
      a2: 'You can obtain Turkish citizenship by purchasing real estate worth at least $400,000 USD. Viaturkey provides expert consultancy for the entire process, from property selection in Istanbul to citizenship application. We offer luxury projects in Beşiktaş, Florya, and along the Kanal Istanbul corridor.',
      q3: 'What are the best Istanbul tours for cruise ship passengers?',
      a3: 'Viaturkey offers private shore excursion tours for cruise ship passengers, covering Istanbul\'s top landmarks including Hagia Sophia, Blue Mosque, Topkapi Palace, and the Grand Bazaar. Tours are 5-8 hours with pick-up and drop-off at the cruise port. Book directly to save 25% compared to third-party platforms.',
      q4: 'Where are the best places for business meetings in Istanbul?',
      a4: 'Top Istanbul restaurants for business meetings include Nusr-Et Steakhouse (Etiler), Paper Moon (Akmerkez), Cipriani (Levent), Ulus 29 (panoramic Bosphorus views), Sunset Grill & Bar, and La Petite Maison. Viaturkey provides a curated guide to business dining venues across Istanbul.',
      q5: 'Is it safe to invest in Istanbul real estate?',
      a5: 'Yes, Istanbul real estate is a strong investment with growing property values. Turkey offers citizenship by investment, residence permits, and a booming market. Viaturkey partners with established developers and offers projects in prime locations such as Beşiktaş, Florya, and the Kanal Istanbul corridor.'
    },
    projects: {
      'tual-comfort-kanal-2': {
        name: 'Kanal Istanbul Project Residences 2nd',
        location: 'Istanbul European Side',
        description: 'A major investment opportunity located on 24,000 sqm of land in Bahçeşehir with 60% green spaces. Situated at the intersection of Istanbul Airport, Kanal Istanbul corridor, North Marmara Highway and main arterial roads. Every apartment features a balcony. Title deed ready.',
        highlights: [
          '480 apartments across 6 blocks + 20 commercial units',
          '24,000 sqm land area — 60% green spaces',
          'Küçükçekmece Lake views',
          'Every apartment has a balcony',
          'Indoor swimming pool, sauna & spa, steam room',
          'Fitness center, basketball court, children\'s playground',
          'Walking paths and family seating areas',
          '24/7 security with CCTV and electronic security system',
          '22 km to Istanbul New Airport',
          '4 km to Küçükçekmece Lake, 3 km to E80 Highway',
          'Near Kanal Istanbul corridor — high value growth potential',
          'Title deed ready — Delivered March 2025',
          'Turkish Citizenship eligible'
        ],
        apartmentTypes: '2+1 (104-130 sqm), 3+1 (163-172 sqm)',
        developer: 'Premium Developer',
        completionStatus: 'Delivered — Title deed ready',
        pricing: 'Contact for pricing'
      },
      'referans-beylikduzu': {
        name: 'European Side Prime Residences',
        location: 'Istanbul European Side',
        description: 'A peaceful family-oriented residential project on 31,000 sqm with 70% green areas. 709 units featuring uniquely designed landscape, city and sea views, with walking-distance access to over 300 shops, malls, hospitals, and West Istanbul Marina.',
        developer: 'Premium Developer',
        completionStatus: 'Under construction',
        apartmentTypes: '2+1, 2+1 Duplex, 3+1, 3.5+1, 3+1 Duplex, 4+1, 4.5+1, 4+1 Duplex, 5+1',
        highlights: [
          '709 units on 31,000 sqm — 70% green areas',
          'City View, Sea View, and Landscape View options',
          'Outdoor & Indoor Swimming Pools',
          'Zen Garden, Lavender & Olive Garden',
          'Sauna, Turkish Bath (Hamam), Fitness Center',
          'Basketball Court, Playground, Kindergarten',
          'Walking distance to 300+ shops, malls, hospitals',
          '24/7 security system',
          '30 km to Istanbul Airport (45 min)',
          '5 km to Metrobus & E-5 Highway',
          'Turkish Citizenship eligible',
          'Residence Permit eligible'
        ]
      }
    },
    medicalTourism: {
      subtitle: 'World-class healthcare at competitive prices — Dental, Hair Transplant & Cosmetic Surgery',
      intro: 'Turkey is one of the top destinations for medical tourism, with a market valued at $4.2–4.6 billion in 2026. Istanbul offers internationally accredited hospitals, JCI-certified clinics, and highly experienced specialists at a fraction of Western prices.',
      hairTitle: 'Hair Transplant FAQ',
      h1q: 'DHI or FUE method — which is better?',
      h1a: 'Both methods aim for permanent hair growth. DHI has shorter recovery time and lower bleeding risk, ideal for adding fullness without full head shaving. FUE covers larger areas in 6-8 hours. Sapphire FUE uses sharper blades for smaller incisions and minimal tissue damage.',
      h2q: 'How many grafts are transplanted and what do they contain?',
      h2a: 'Each graft contains approximately 2-3 hair follicles. The number of grafts is determined during consultation based on the donor area density and the area to be covered.',
      h3q: 'Can women get hair transplants? Are there scars?',
      h3a: 'Yes, FUE hair transplant for women leaves no visible scars. The transplanted hair blends seamlessly with natural hair. FUT technique has higher scarring risk and is not recommended for women.',
      h4q: 'What are the side effects and when can I dye my hair?',
      h4a: 'Possible side effects include temporary swelling, bruising around eyes, and numbness in the transplanted area. Hair dyeing should be avoided for 8-12 months while the transplant fully matures.',
      cosmeticTitle: 'Cosmetic Surgery FAQ',
      c1q: 'Are nose fillers permanent?',
      c1a: 'Hyaluronic acid nose fillers last 6 months to 1 year. Fat injection fillers last 3-5 years. Stem cell-supported fat injections can last up to 5 years.',
      c2q: 'Can a Fox Eye procedure be repeated?',
      c2a: 'Yes. The Fox Eye lift uses dissolving threads, so it is repeatable. Duration varies based on skin quality.',
      c3q: 'Does a French Lift stop aging?',
      c3a: 'No. While it does not stop aging, it eliminates visible signs like sagging and wrinkles and triggers collagen production for a lifting effect.',
      c4q: 'Are cheekbone fillers permanent?',
      c4a: 'Hyaluronic acid fillers last 6 months to 1 year. Fat injection fillers last 2-3 years. Results vary based on individual tissue and cell structures.',
      healthTurkiye: 'Plan your treatment on the official HealthTürkiye portal',
      citation: 'Source: HealthTürkiye (healthturkiye.gov.tr) — Official medical tourism portal of the Republic of Turkey. Market data: 2026 industry analysis.'
    },
    stats: {
      title: 'Istanbul: Key Facts & Figures',
      titleCity: 'Istanbul',
      titleFacts: 'Key Facts & Figures',
      tourists: 'International tourists visit Istanbul annually',
      citizenship: 'Minimum investment for Turkish citizenship',
      residence: 'Minimum for Turkish Residence Permit',
      languages: 'Languages: English, Russian, Arabic, Turkish',
      savings: 'Savings when you book directly with Viaturkey',
      citation: 'According to Viaturkey Investments & Tourism, Istanbul\'s leading travel consultancy serving clients in 4 languages since establishment.'
    },
    map: {
      title: 'Visit Our Office',
      openInMaps: 'Open in Google Maps'
    },
    contact: {
      title: 'Contact Us',
      getInTouch: 'Get in Touch',
      sendMessage: 'Send us a message',
      openForm: 'Open Contact Form',
      followYoutube: 'Follow us on YouTube',
      followInstagram: 'Follow us on Instagram',
      followTiktok: 'Follow us on TikTok',
      followTwitter: 'Follow us on X (Twitter)'
    },
    inquiry: {
      title: 'Submit Inquiry',
      namePlaceholder: 'Your Name *',
      emailPlaceholder: 'Your Email *',
      phonePlaceholder: 'Phone Number',
      messagePlaceholder: 'Your Message *',
      arrivalFlight: 'Arrival Flight No *',
      departureFlight: 'Departure Flight No *',
      plannedDate: 'Planned Tour Date *',
      specialRequirements: 'Special Requirements & Additional Info About The Travelers',
      flightDetails: 'Flight & Tour Details',
      priceQuote: 'We will get in touch with you asap with the best price quote.',
      submit: 'Submit Inquiry',
      bookCall: 'Book an Appointment',
      submitting: 'Submitting...',
      inquirySuccess: 'Inquiry submitted successfully!',
      inquiryError: 'Error submitting inquiry.',
      interestedIn: "I'm interested in"
    },
    footer: {
      rights: '© 2026 Viaturkey Investments & Tourism Co. All rights reserved.',
      tagline: 'Your trusted partner in Turkey'
    },
    tripadvisor: {
      title: 'Recommended by TripAdvisor Guests',
      linkText: 'View Our Reviews',
      text: 'We pride ourselves on our excellent TripAdvisor reviews',
      seeReviews: 'See Reviews'
    },
    blog: {
      heroTitle: 'Istanbul Travel Blog',
      heroSubtitle: 'Expert guides, travel tips, and insider knowledge for your Istanbul journey',
      allCategory: 'All',
      cityTours: 'City Tours',
      shoreExcursions: 'Shore Excursions',
      foodCulture: 'Food & Culture',
      travelTips: 'Travel Tips',
      turkishCitizenship: 'Turkish Citizenship',
      readMore: 'Read More',
      backToBlog: 'Back to Blog',
      posts: [
        { title: 'The Ultimate Istanbul Shore Excursion Guide from Galataport', excerpt: 'Everything you need to know about planning the perfect shore excursion from Galataport cruise terminal in Istanbul.', readTime: '8 min read' },
        { title: 'Best Istanbul Food Tour: A Culinary Journey Through the City', excerpt: "Discover Istanbul's vibrant food scene from street kebabs to Ottoman palace cuisine with our expert local guides.", readTime: '6 min read' },
        { title: 'Turkish Citizenship by Investment: Complete 2026 Guide', excerpt: 'Step-by-step guide to obtaining Turkish citizenship through real estate investment. Requirements, process, and timeline.', readTime: '10 min read' },
        { title: 'Perfect Istanbul City Tour Itinerary: Old City in One Day', excerpt: 'How to see Hagia Sophia, Blue Mosque, Topkapi Palace, and the Grand Bazaar in a single guided tour.', readTime: '7 min read' },
        { title: '15 Essential Istanbul Travel Tips for First-Time Visitors', excerpt: 'From currency exchange to transport, everything a first-time visitor needs to know before arriving in Istanbul.', readTime: '5 min read' },
        { title: 'Kanal Istanbul: Why Smart Investors Are Buying Now', excerpt: "The mega canal project is reshaping Istanbul's European side. Here's why real estate along the corridor is booming.", readTime: '9 min read' }
      ],
      shore: {
        byLine: 'By Viaturkey Team',
        intro: "If you're arriving in Istanbul by cruise ship, you're docking at one of the most exciting cruise terminals in the world — Galataport. Located in the heart of the Karakoy district, Galataport puts you within reach of Istanbul's greatest landmarks. But with limited time in port, planning an efficient Istanbul shore excursion is essential.",
        intro2: "At Viaturkey, we've been guiding cruise passengers through Istanbul for years. Here's everything you need to know to make the most of your time ashore.",
        h2_galataport: 'What is Galataport and Why Does It Matter?',
        p_galataport1: "Galataport is Istanbul's modern cruise terminal on the European side of the Bosphorus; it welcomed its first cruise ship in 2021. Unlike the old terminal, Galataport is centrally located — just minutes from Taksim Square, the Spice Bazaar, and the historic Sultanahmet district. This means more time sightseeing and less time stuck in traffic.",
        p_galataport2: 'For cruise passengers, this is a game-changer. A private Istanbul shore excursion from Galataport can cover more ground in less time compared to the old port location.',
        h2_itinerary: 'Top Itinerary: Istanbul Shore Excursion in 6-8 Hours',
        p_itinerary: "Here's the itinerary our licensed Istanbul guides recommend for first-time visitors with 6-8 hours in port:",
        stops: ['Hagia Sophia — The 1,500-year-old architectural masterpiece. Once a church, then a mosque, now a mosque again. With a private guide, we handle the tickets and the timing — choosing the quieter entry slots — and you get a deep understanding of its layered history.', 'Blue Mosque (Sultan Ahmed) — Istanbul\'s most famous mosque with its six minarets and cascading domes. We time visits to avoid peak crowds.', 'Topkapi Palace — The Ottoman sultans\' residence for 400 years. The Harem section and treasury are must-sees.', 'Grand Bazaar — One of the world\'s oldest and largest covered markets with over 4,000 shops. Your guide helps you navigate and find authentic goods.', 'Spice Bazaar — A sensory feast of Turkish delight, saffron, dried fruits, and artisan teas.'],
        h2_why: 'Why Book a Private Galataport Tour Instead of Ship Excursions?',
        p_why: 'Cruise ship excursions are convenient but come with drawbacks: large groups (30-50 people), rigid schedules, and prices 25-40% higher than booking directly with a local operator. Here\'s why a private Istanbul tour with Viaturkey is the better choice:',
        reasons: ['Personalized pace — You set the itinerary, not a group of strangers', 'Licensed local guide — All our guides are government-licensed and speak fluent English', 'Door-to-door service — We meet you at the Galataport exit and return you to your ship', 'Save 25%+ — Direct booking with no platform fees or middleman markup', 'Ship departure guarantee — We monitor your ship\'s schedule and ensure you\'re back on time'],
        h2_food: 'Istanbul Food Stops During Your Shore Excursion',
        p_food: 'No Istanbul visit is complete without tasting the cuisine. During your Galataport shore excursion, we include stops at hand-picked local restaurants:',
        foodStops: ['Authentic Turkish breakfast with simit, cheese, olives, and fresh-brewed cay', 'World-famous Istanbul kebabs at a family-run restaurant near the Grand Bazaar', 'Baklava tasting at a century-old pastry shop', 'Fresh-squeezed pomegranate juice from a street vendor'],
        foodLink: 'Istanbul food tour packages',
        h2_know: 'What to Know Before Your Shore Excursion',
        knowItems: ['Currency: Turkish Lira (TL). Most tourist spots accept credit cards, but carry cash for the bazaars.', 'Dress code: Mosques require covered shoulders and knees. Headscarves are provided at the entrance.', 'Best months: April-June and September-November for mild weather and fewer crowds.', 'Language: Our guides speak English, Russian, Arabic, and Turkish.'],
        h2_faq: 'Frequently Asked Questions',
        faqs: [
          { q: 'How long does a Galataport shore excursion take?', a: "Most shore excursions last 6-8 hours, which is enough to cover all major landmarks. We customize based on your ship's schedule." },
          { q: "Can you guarantee we'll be back to the ship on time?", a: "Absolutely. We monitor your ship's departure schedule and build in a safety buffer. In years of service, we've never had a guest miss their ship." },
          { q: 'Do you offer tours in languages other than English?', a: 'Yes. Our licensed guides offer tours in English, Russian, Arabic, and Turkish.' },
          { q: 'How much does a private shore excursion cost?', a: 'Pricing depends on group size and itinerary. Contact us on WhatsApp for a personalized quote — typically 25% less than cruise ship excursions.' }
        ],
        ctaTitle: 'Ready to Plan Your Istanbul Shore Excursion?',
        ctaText: 'Message us directly on WhatsApp for a personalized itinerary and instant quote. No middleman, no hidden fees.',
        ctaBtn: 'Message Us on WhatsApp'
      }
    },
    newProject: {
      badge: 'NEW PROJECT',
      title: 'Central Istanbul Metro Residences 2026 \u2014 Now Selling',
      subtitle: 'Premium residences on Istanbul\u2019s Bas\u0131n Ekspres axis \u00b7 From USD 259,000 \u00b7 Eligible for Turkish Citizenship (min. USD 400,000 combined investment)',
      cta: 'Explore the Project'
    }
  };

